import { Component, Input } from '@angular/core';

@Component({
  templateUrl: './park-meter.html',
  selector: 'park-meter'
})
export class ParkMeterComponent {
  @Input() quantity: number;
}



// WEBPACK FOOTER //
// ./src/app/dashboard/parks/park/meter/park-meter.component.ts